/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { LinkButtonProps } from "./interfaces";
import { linkButtonStyles } from "./styles";

export const LinkButton: React.FunctionComponent<LinkButtonProps> = (props) => {
  const { className, href, onClick } = props;
  return (
    <a
      href={href}
      className={`link-button ${className ? className : ""}`}
      onClick={(event: React.MouseEvent) => {
        onClick && onClick(event);
      }}
      css={linkButtonStyles()}
      target={`${href ? "_blank" : ""}`}
    >
      {props.children}
    </a>
  );
};
